import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Gift, CheckCircle2, Store } from "lucide-react";

export default function VipSignup() {
  const { id } = useParams();
  const [info, setInfo] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [form, setForm] = useState({ first_name: "", email: "", consent: false });
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/public/crm/${id}`).then((r) => setInfo(r.data)).catch(() => setNotFound(true));
  }, [id]);

  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (!form.consent) { setErr("Merci de cocher la case de consentement."); return; }
    setBusy(true);
    try { await api.post(`/public/crm/${id}/subscribe`, form); setDone(true); }
    catch (e) { setErr(e?.response?.data?.detail || "Une erreur est survenue."); }
    finally { setBusy(false); }
  };

  if (notFound) return <div className="min-h-screen grid place-items-center text-slate-500">Page introuvable.</div>;
  if (!info) return <div className="min-h-screen grid place-items-center text-slate-400">Chargement…</div>;

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-slate-50 grid place-items-center p-4" data-testid="vip-signup-page">
      <div className="w-full max-w-md bg-white rounded-3xl border border-slate-200 shadow-xl p-7">
        <div className="flex items-center gap-2 text-[#E05638] font-extrabold"><Store size={20} /> {info.business_name}</div>
        {done ? (
          <div className="mt-6 text-center" data-testid="vip-done">
            <CheckCircle2 size={48} className="mx-auto text-emerald-500" />
            <h1 className="mt-3 font-heading text-2xl font-extrabold text-slate-900">Vérifiez votre boîte mail</h1>
            <p className="mt-2 text-slate-600 text-sm">Nous venons de vous envoyer un e-mail de confirmation. Cliquez sur le lien pour valider votre inscription{info.welcome_offer ? " et recevoir votre cadeau de bienvenue" : ""}.</p>
          </div>
        ) : (
          <>
            <h1 className="mt-4 font-heading text-3xl font-extrabold text-slate-900">Rejoignez la liste VIP</h1>
            <p className="mt-2 text-slate-600 text-sm">Recevez en avant-première les bons plans et nouveautés{info.city ? ` à ${info.city}` : ""}.</p>
            {info.welcome_offer && (
              <div className="mt-4 flex items-center gap-2 rounded-xl bg-orange-50 border border-orange-200 text-[#9A3412] px-4 py-3 text-sm font-semibold" data-testid="vip-welcome-offer">
                <Gift size={18} /> Cadeau de bienvenue : {info.welcome_offer}
              </div>
            )}
            <form onSubmit={submit} className="mt-5 space-y-4">
              <div><Label>Prénom</Label><Input value={form.first_name} onChange={(e) => setForm((f) => ({ ...f, first_name: e.target.value }))} data-testid="vip-first-name" /></div>
              <div><Label>E-mail *</Label><Input type="email" required value={form.email} onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))} data-testid="vip-email" /></div>
              <label className="flex items-start gap-2 text-xs text-slate-600 cursor-pointer">
                <input type="checkbox" checked={form.consent} onChange={(e) => setForm((f) => ({ ...f, consent: e.target.checked }))} className="mt-0.5" data-testid="vip-consent" />
                <span>J'accepte de recevoir par e-mail les offres et actualités de {info.business_name}. Je peux me désinscrire à tout moment.</span>
              </label>
              {err && <div className="text-sm text-red-600" data-testid="vip-error">{err}</div>}
              <Button type="submit" disabled={busy} className="w-full btn-shine text-white" data-testid="vip-submit">{busy ? "…" : "Je m'inscris"}</Button>
            </form>
            <p className="mt-3 text-center text-[11px] text-slate-400">Propulsé par PROXIreduc-28</p>
          </>
        )}
      </div>
    </div>
  );
}
